import { ScopeComponent } from '@app/features/scoping/models/component.model'
import { ComponentChanges } from '@app/shared/components/scope-elements/models/entities-with-changes/component-with-changes.interface'

export function getComponentChanges(component: ScopeComponent, previewComponent: ScopeComponent): ComponentChanges {
  if (!previewComponent) previewComponent = component

  return {
    quantity: {
      old: component?.quantity,
      new: previewComponent?.quantity,
    },
    rateCardTotalHours: {
      old: component?.getTotalRateCardHours(),
      new: previewComponent?.getTotalRateCardHours(),
    },
    agencyPrice: {
      old: component?.getTotalSellingPrice()?.amount,
      new: previewComponent?.getTotalSellingPrice()?.amount,
    },
    markup: {
      old: component?.getMarkup() || 0,
      new: previewComponent?.getMarkup() || 0,
    },
    totalSellingPrice: {
      old: component?.getTotalSellingPrice()?.amount,
      new: previewComponent?.getTotalSellingPrice()?.amount,
    },
    quantityModifier: {
      old: component?.quantityModifier || 1,
      new: previewComponent?.quantityModifier || 1,
    },
    priceModifier: {
      old: component?.priceModifier || 1,
      new: previewComponent?.priceModifier || 1,
    },
  }
}
